import { render, staticRenderFns } from "./EditArticle.page.vue?vue&type=template&id=3771076b&"
import script from "./EditArticle.page.vue?vue&type=script&lang=js&"
export * from "./EditArticle.page.vue?vue&type=script&lang=js&"
import style0 from "./EditArticle.page.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports